import { render, staticRenderFns } from "./BaseListItemIcon.vue?vue&type=template&id=24b8e9b9&scoped=true&"
import script from "./BaseListItemIcon.vue?vue&type=script&lang=js&"
export * from "./BaseListItemIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b8e9b9",
  null
  
)

export default component.exports